<div class="flex-row">
    <ng-container
        *ngrxLet="currentHierarchicalSelectionNodeItem$ as currentHierarchicalSelectionNodeItem"
    >
        <ng-container
            *ngrxLet="currentHierarchicalSelectionIsRoot$ as currentHierarchicalSelectionIsRoot"
        >
            <cds-select layout="vertical" controlWidth="stretch">
                <label>Saved hierarchy levels</label>
                <select
                    name="hierarchical-selection-node"
                    class="selection-node-select"
                    [ngModel]="currentHierarchicalSelectionNodeItem"
                    [compareWith]="compareSelectionTreeItems"
                    (ngModelChange)="setSelection($event)"
                >
                    <option [ngValue]="defaultHierarchicalSelectionNodeItem">All cells</option>
                    <ng-container *ngFor="let item of savedHierarchicalSelectionNodeItems$ | async">
                        <option [ngValue]="item">
                            {{ '&nbsp;'.repeat((item.level - 1) * 3) + '\u21B3 ' + item.name }}
                        </option>
                    </ng-container>
                </select>
            </cds-select>
            <ng-container *ngrxLet="isSharedCase$ as isSharedCase">
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="isSharedCase"
                    (click)="addHierarchicalSelectionNode()"
                >
                    Send down
                </cds-button>
                <cds-button
                    size="sm"
                    action="outline"
                    [disabled]="currentHierarchicalSelectionIsRoot || isSharedCase"
                    (click)="removeHierarchicalSelectionNode(currentHierarchicalSelectionNodeItem)"
                >
                    Send up
                </cds-button>
                <button
                    size="sm"
                    [disabled]="currentHierarchicalSelectionIsRoot || isSharedCase"
                    (click)="
                        removeHierarchicalSelectionNodeRecursively(
                            currentHierarchicalSelectionNodeItem
                        )
                    "
                    class="icon-button"
                >
                    <cds-icon shape="trash"></cds-icon>
                </button>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
